import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import axios from 'axios';
import AACChromeAPI from '@amzn/aac-chrome-api';
import { selectFooterState } from './store/slice';
import {
  selectIsForceDesktopSite,
  selectIsMobileWeb,
  selectIsMobileWebView,
} from 'src/app/slice';
import { logger } from 'src/commons/utils/logger';
import { FooterViewSwitcherPublisher } from 'src/commons/utils/metrics';
import {
  Components,
  FOOTER_FORCE_DESKTOP_ENDPOINT,
  FOOTER_FORCE_MOBILE_ENDPOINT,
} from 'src/commons/constants';
import didElementLoad from 'src/commons/utils/didElementLoad';
import { useCTCIMetrics, useLogWeblab } from 'src/commons/hooks';
import FooterComponent from './components/Footer';
import { markComponentReady } from 'src/commons/utils/logWithTakt';
import { FooterBundleProvider } from 'src/providers/PantherLocalizationProvider/PantherLocalizationProvider';
import FeedbackTrigger from './components/FeedbackTrigger';
import publishNavLoadDuration from './publishNavLoadDuration';
import { loadHmhBundleScript } from '../helpmehere/loadHmhBundleScript';

export const Footer: React.VFC = () => {
  const footerStates = useSelector(selectFooterState);
  const isMobile = useSelector(selectIsMobileWeb);
  const isForceDesktop = useSelector(selectIsForceDesktopSite);
  const isMobileWebView = useSelector(selectIsMobileWebView);

  useCTCIMetrics({ isMobile: isMobile && !isForceDesktop });

  const toggleView = async () => {
    const refName = window?.location?.href || null;
    const postURL = !isForceDesktop
      ? `${FOOTER_FORCE_DESKTOP_ENDPOINT}${refName}`
      : `${FOOTER_FORCE_MOBILE_ENDPOINT}${refName}`;

    try {
      const response = await axios(postURL, {
        withCredentials: false,
      });

      if (response) {
        FooterViewSwitcherPublisher.publishCounterMonitor('success', 1);
        window.location.reload();
      }
    } catch (error) {
      logger.error(
        `Error occurred while switching to ${
          isForceDesktop ? 'mobile' : 'desktop'
        } view in AACChrome, error: ${error}`,
      );
      FooterViewSwitcherPublisher.publishCounterMonitor('error', 1);
    }
  };

  useLogWeblab();

  useEffect(() => {
    didElementLoad('footer');
    markComponentReady(Components.FOOTER);
    publishNavLoadDuration();
    (async () => {
      await loadHmhBundleScript();
      AACChromeAPI.getCommonEventTarget().addEventListener(
        'ChromeConfigurationChange',
        loadHmhBundleScript,
      );
    })();
  }, []);

  return (
    <FooterBundleProvider>
      <FooterComponent
        {...footerStates}
        isMobile={isMobile}
        isMobileWebView={isMobileWebView} //  seller App
        isForceDesktop={isForceDesktop}
        toggleView={toggleView}
      />
      <FeedbackTrigger />
    </FooterBundleProvider>
  );
};
